import React from 'react';
import { Tweet } from 'react-tweet';

import Container from '@/components/Container';

interface TweetData {
  id: string;
}

const tweets: TweetData[] = [
  { id: '1844391412663730519' },
  { id: '1844392043982037477' },
  { id: '1844392611047743587' },
];

const TwitterFeed: React.FC = () => {
  return (
    <Container className='max-w-6xl mx-auto'>
      <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 justify-items-center'>
        {tweets.map((tweet) => (
          <div key={tweet.id} className='rounded-xl w-full max-w-[400px]'>
            <Tweet id={tweet.id} />
          </div>
        ))}
      </div>
    </Container>
  );
};

export default TwitterFeed;
